import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

/**
 * Component for section title with icon for the edit okr and view kr form
 * @example gh-section-title(title="progress_cap" iconType="progress")
 * @param title the text used as a title
 * @param iconType type of the icon
 */
@Component({
  selector: "section-title-with-icon",
  templateUrl: "./section-title-with-icon.component.html",
  styleUrls: ["./section-title-with-icon.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionTitleWithIconComponent {
  @Input() public title: string;
  @Input() public iconType: string;
}
